import React from 'react';
import PropTypes from "prop-types";
import PivotalAttachmentsApi from "../../../js/csf/pivotal/PivotalAttachmentsApi";
import {stopLoadingSpinner} from "../../csf-ufc-pivotal/includes/utils";
import {returnFileSize} from '../includes/utils';

export function CsfPivotalFournisseurRecognitionDetailsTab3({formDetail, apiUrl, apiEnv, accessToken}) {

  let lastCycle = {}
  if (formDetail.Cycle__Secondary && formDetail.Cycle__Secondary.length > 0) {
    lastCycle = formDetail.Cycle__Secondary.find(cycle => cycle.REDU_Activity__Cycle_Id === formDetail.Last_REDU_Cycle_Id);
  }

  function downloadDocument($type) {

    let form = 'CSF_EP_Fichiers';
    if ($type === 'Formation_Plan') {
      form = 'CSF_EP_Fichiers_Activity';
    }

    const requestData = {
      form: form,
      recordId: formDetail.Last_REDU_Cycle_Id, // peut-etre le cycle qui contient le document?
      fieldName: $type

    }
    const pivotalAttachmentsApi = new PivotalAttachmentsApi(apiUrl, apiEnv, accessToken); // Use a different variable name here
    pivotalAttachmentsApi.callTaskEndpoint(requestData, '_Espace_Partenaire')
      .then(blob => {
        stopLoadingSpinner();
        if (blob) {
          let filename = lastCycle.Formation_Plan;
          if ($type === 'Evaluation') {
            filename = lastCycle.Evaluation;
          }
          if ($type === 'EP_Doc_Comp_1') {
            filename = lastCycle.EP_Doc_Comp_1;
          }
          if ($type === 'EP_Doc_Comp_2') {
            filename = lastCycle.EP_Doc_Comp_2;
          }
          if ($type === 'EP_Doc_Comp_3') {
            filename = lastCycle.EP_Doc_Comp_3;
          }
          if ($type === 'EP_Doc_Comp_4') {
            filename = lastCycle.EP_Doc_Comp_4;
          }
          exportCSV(blob, filename);
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to build the Export CSV
  * */
  function exportCSV(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  return (
    <div className="tab-panel hide" id="content-tab" role="tabpanel">
      {Object.keys(lastCycle).length > 0 && lastCycle.Formation_Plan && (
        <div className="tab-line-item d-flex align-items-center">
          <div className="tab-line-title">
            {window.Drupal.t('fournisseur.recognition.detail.plan_pdf')}
          </div>
          <div className="tab-line-value">
            <div>{lastCycle.Formation_Plan} {lastCycle.RN_Formation_Plan_FZ ? '(' + returnFileSize(lastCycle.RN_Formation_Plan_FZ) + ')' : ''}</div>
          </div>
          <div className="tab-line-button">
            <a href="#" className='btn-outlined btn-icon-only download-media'
               onClick={() => downloadDocument('Formation_Plan')}
               title={window.Drupal.t('fournisseur.recognition.detail.details.download')}>
              <i className="icon icon-download supplier-icon"><span className="d-none">&nbsp;</span></i>
            </a>
          </div>
        </div>
      )}
      {Object.keys(lastCycle).length > 0 && lastCycle.Evaluation && (
        <div className="tab-line-item d-flex align-items-center">
          <div className="tab-line-title">
            {window.Drupal.t('fournisseur.recognition.detail.eval_pdf')}
          </div>
          <div className="tab-line-value">
            <div>{lastCycle.Evaluation} {lastCycle.RN_Evaluation_FZ ? '(' + returnFileSize(lastCycle.RN_Evaluation_FZ) + ')' : ''}</div>
          </div>
          <div className="tab-line-button">
            <a href="#" disabled className='btn-outlined btn-icon-only download-media'
               onClick={() => downloadDocument('Evaluation')}
               title={window.Drupal.t('fournisseur.recognition.detail.details.download')}>
              <i className="icon icon-download supplier-icon"><span className="d-none">&nbsp;</span></i>
            </a>
          </div>
        </div>
      )}

      {Object.keys(lastCycle).length > 0 && lastCycle.EP_Doc_Comp_1 && (
        <div className="tab-line-item d-flex align-items-center">
          <div className="tab-line-title">
            {window.Drupal.t('fournisseur.creation_form.form.fields.file_eP_Doc_Comp_1')}
          </div>
          <div className="tab-line-value">
            <div>{lastCycle.EP_Doc_Comp_1} {lastCycle.RN_EP_Doc_Comp_1_FZ ? '(' + returnFileSize(lastCycle.RN_EP_Doc_Comp_1_FZ) + ')' : ''}</div>
          </div>
          <div className="tab-line-button">
            <a href="#" disabled className='btn-outlined btn-icon-only download-media'
               onClick={() => downloadDocument('RN_EP_Doc_Comp_1')}
               title={window.Drupal.t('fournisseur.recognition.detail.details.download')}>
              <i className="icon icon-download supplier-icon"><span className="d-none">&nbsp;</span></i>
            </a>
          </div>
        </div>
      )}

      {Object.keys(lastCycle).length > 0 && lastCycle.EP_Doc_Comp_2 && (
        <div className="tab-line-item d-flex align-items-center">
          <div className="tab-line-title">
            {window.Drupal.t('fournisseur.creation_form.form.fields.file_eP_Doc_Comp_2')}
          </div>
          <div className="tab-line-value">
            <div>{lastCycle.EP_Doc_Comp_2} {lastCycle.RN_EP_Doc_Comp_2_FZ ? '(' + returnFileSize(lastCycle.RN_EP_Doc_Comp_2_FZ) + ')' : ''}</div>
          </div>
          <div className="tab-line-button">
            <a href="#" disabled className='btn-outlined btn-icon-only download-media'
               onClick={() => downloadDocument('EP_Doc_Comp_2')}
               title={window.Drupal.t('fournisseur.recognition.detail.details.download')}>
              <i className="icon icon-download supplier-icon"><span className="d-none">&nbsp;</span></i>
            </a>
          </div>
        </div>
      )}

      {Object.keys(lastCycle).length > 0 && lastCycle.EP_Doc_Comp_3 && (
        <div className="tab-line-item d-flex align-items-center">
          <div className="tab-line-title">
            {window.Drupal.t('fournisseur.creation_form.form.fields.file_eP_Doc_Comp_3')}
          </div>
          <div className="tab-line-value">
            <div>{lastCycle.EP_Doc_Comp_3} {lastCycle.RN_EP_Doc_Comp_3_FZ ? '(' + returnFileSize(lastCycle.RN_EP_Doc_Comp_3_FZ) + ')' : ''}</div>
          </div>
          <div className="tab-line-button">
            <a href="#" disabled className='btn-outlined btn-icon-only download-media'
               onClick={() => downloadDocument('EP_Doc_Comp_3')}
               title={window.Drupal.t('fournisseur.recognition.detail.details.download')}>
              <i className="icon icon-download supplier-icon"><span className="d-none">&nbsp;</span></i>
            </a>
          </div>
        </div>
      )}

      {Object.keys(lastCycle).length > 0 && lastCycle.EP_Doc_Comp_4 && (
        <div className="tab-line-item d-flex align-items-center">
          <div className="tab-line-title">
            {window.Drupal.t('fournisseur.creation_form.form.fields.file_eP_Doc_Comp_4')}
          </div>
          <div className="tab-line-value">
            <div>{lastCycle.EP_Doc_Comp_4} {lastCycle.RN_EP_Doc_Comp_4_FZ ? '(' + returnFileSize(lastCycle.RN_EP_Doc_Comp_4_FZ) + ')' : ''}</div>
          </div>
          <div className="tab-line-button">
            <a href="#" disabled className='btn-outlined btn-icon-only download-media'
               onClick={() => downloadDocument('EP_Doc_Comp_4')}
               title={window.Drupal.t('fournisseur.recognition.detail.details.download')}>
              <i className="icon icon-download supplier-icon"><span className="d-none">&nbsp;</span></i>
            </a>
          </div>
        </div>
      )}

      <div className="tab-line-item d-flex align-items-center">
        <div className="tab-line-title">
          {window.Drupal.t('fournisseur.recognition.detail.passing.grade')}
        </div>
        {Object.keys(lastCycle).length > 0 && lastCycle.Hard_Questions && (
          <div className="tab-line-value">
            {lastCycle.Passing_Grade && (
              lastCycle.Passing_Grade + '%'
            )}
          </div>
        )}
      </div>

      <div className="tab-line-item d-flex align-items-center">
        <div className="tab-line-title">
          {window.Drupal.t('fournisseur.recognition.detail.control')}
        </div>
        <div className="tab-line-value">
          {Object.keys(lastCycle).length > 0 && (
            lastCycle.Activity_Participation_Control
          )}
        </div>
      </div>
    </div>
  );
}

CsfPivotalFournisseurRecognitionDetailsTab3.propTypes = {
  formDetail: PropTypes.object,
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  accessToken: PropTypes.string
};
